import { ResponsiveBar } from "@nivo/bar";

interface IChartBarProps {
  dataSet: any[];
  colorScheme: string;
  xLabelKey: string;
  yLabelKey: string;
  yLegendString?: string;
  // eslint-disable-next-line no-unused-vars
  xFormat?: (value: number) => string;
}

function ChartBar({
  dataSet,
  xLabelKey,
  yLabelKey,
  colorScheme,
  yLegendString,
  xFormat,
}: IChartBarProps) {
  return (
    <div className="flex-1 h-full w-full">
      <ResponsiveBar
        data={dataSet || []}
        indexBy={xLabelKey}
        keys={[yLabelKey]}
        margin={{ top: 20, right: 20, bottom: 50, left: 50 }}
        padding={0.4}
        maxValue="auto"
        enableLabel={false}
        enableGridY={false}
        borderRadius={10}
        colors={colorScheme}
        axisBottom={{
          format: xFormat,
        }}
        axisLeft={{
          legend: yLegendString,
          legendOffset: -40,
          legendPosition: "middle",
        }}
        valueScale={{ type: "linear", min: 0, max: "auto" }}
      />
    </div>
  );
}

export default ChartBar;
